// skipcq: JS-W1028
import { useCallback } from 'react';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import PropTypes from 'prop-types';

export const TAB_NEW_REVIEWS = 'new-reviews';
export const TAB_ALL_REVIEWS = 'all-reviews';

function ReviewDetailsTabs({ activeTab, onTabChange }) {
  const handleTabChange = useCallback(
    (_event, nextTab) => {
      if (typeof onTabChange === 'function') {
        onTabChange(nextTab);
      }
    },
    [onTabChange],
  );

  return (
    <Tabs
      value={activeTab}
      onChange={handleTabChange}
      aria-label="Review details tabs"
      variant="fullWidth"
      sx={{
        borderBottom: 1,
        borderColor: 'divider',
        minHeight: 48,
      }}
    >
      <Tab value={TAB_NEW_REVIEWS} label="New Reviews" />
      <Tab value={TAB_ALL_REVIEWS} label="All Reviews" />
    </Tabs>
  );
}

ReviewDetailsTabs.propTypes = {
  activeTab: PropTypes.oneOf([TAB_NEW_REVIEWS, TAB_ALL_REVIEWS]).isRequired,
  onTabChange: PropTypes.func.isRequired,
};

export default ReviewDetailsTabs;
